import VideoCountdown from './main/video-countdown';

$(() => {
    const productWorkshopContext = window.__PRODUCT_WORKSHOP_CONTEXT__ || {}; // fallback if context not set

    // Immediately popup pre test if is not solved.
    if (!productWorkshopContext.preTestSubmission) {
        $('#pre-test-modal').modal('show');
    }

    // If pre test solved on any click (except unmute) popup post test.
    if (productWorkshopContext.preTestSubmission && !productWorkshopContext.postTestSubmission) {
        $('body').on('click', (ev) => {
            const unmuteClass = 'oo-unmute';
            if (!($(ev.target).hasClass(unmuteClass) || $(ev.target).parents(`.${unmuteClass}`).length)) {
                $('#post-test-modal').modal('show');
                $('body').unbind('click');
            }
        });

        // Disable first click to another piece of content.
        $('a').on('click', (ev) => {
            ev.preventDefault();
            $('a').unbind('click');
        });
    }

    // Pause video on any modal show.
    $('div[id$=-test-modal]').on('shown.bs.modal', () => {
        window.player.pause();
    });

    // Play video on hidden modal or countdown and play next video.
    $('div[id$=-test-modal]').on('hidden.bs.modal', () => {
        window.autoplayEnabled = true;

        const isDurationEnd = Math.ceil(window.player.currentTime()) >= window.player.duration();

        if (isDurationEnd) {
            if (window.__NEXT_VIDEO_CONTEXT__) {
                const countdown = new VideoCountdown({
                    nextVideoAPIUrl: window.__NEXT_VIDEO_CONTEXT__.nextVideoAPIUrl,
                    initialTime: window.__NEXT_VIDEO_CONTEXT__.initialTime,
                    videoCountdownCompletedUrl: window.__NEXT_VIDEO_CONTEXT__.videoCountdownCompletedUrl,
                });
                countdown.run();
            }
        } else {
            window.player.play();
        }
    });
});
